import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const cur = (i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);

  const set = (lng) => {
    if (lng === cur) return;
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("lang", lng);
    } catch {
      /* ignore */
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = lng;
    }
  };

  if (compact) {
    return (
      <button
        onClick={() => set(cur === "fr" ? "en" : "fr")}
        className="flex items-center gap-1 text-xs uppercase tracking-widest text-white/70 hover:text-white transition"
        data-testid="lang-switcher-compact"
        aria-label="Change language"
      >
        <Globe className="w-3.5 h-3.5" />
        <span>{cur === "fr" ? "FR" : "EN"}</span>
      </button>
    );
  }

  return (
    <div className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold" data-testid="lang-switcher">
      <button
        onClick={() => set("fr")}
        className={`px-2 py-1 transition ${
          cur === "fr"
            ? "bg-white text-[#001F3F]"
            : "text-white/60 hover:text-white"
        }`}
        data-testid="lang-fr"
      >
        FR
      </button>
      <span className="text-white/30">/</span>
      <button
        onClick={() => set("en")}
        className={`px-2 py-1 transition ${
          cur === "en"
            ? "bg-white text-[#001F3F]"
            : "text-white/60 hover:text-white"
        }`}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
